/*
 * Voegt een kortingsbadge toe naast de prijs op productpagina's
 * die de custom 'product-page-enhanced' sectie gebruiken (product-price-row).
 * Prijspsychologie: toont het grootste getal — als het bedrag aan korting
 * (in hele euro's) hoger is dan het percentage, wordt "€X KORTING" getoond,
 * anders "Bespaar X%".
 * Kleuren komen uit Thema-instellingen > Kortingsbadge (window.discountBadgeColors).
 */
(function () {
  var STYLE_ID = 'mae-discount-badge-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var colors = window.discountBadgeColors || {};
    var bg = colors.bg || '#332728';
    var text = colors.text || '#FFFFFF';
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.product-discount-badge{' +
      'display:inline-block;' +
      'padding:0.4rem 1rem;' +
      'background-color:' + bg + ';' +
      'color:' + text + ';' +
      'font-size:1.2rem;' +
      'font-weight:600;' +
      'line-height:14px;' +
      'border-radius:999px;' +
      'white-space:nowrap;' +
      '}';
    document.head.appendChild(style);
  }

  function parseMoney(text) {
    if (!text) return null;
    var cleaned = text.replace(/[^0-9,.-]/g, '');
    if (cleaned.indexOf(',') > -1 && cleaned.indexOf('.') > -1) {
      // e.g. 1.234,56 -> 1234.56
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else if (cleaned.indexOf(',') > -1) {
      // e.g. 84,95 -> 84.95
      cleaned = cleaned.replace(',', '.');
    }
    var value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
  }

  function addBadges() {
    var rows = document.querySelectorAll('.product-price-row');
    rows.forEach(function (row) {
      if (row.querySelector('.product-discount-badge')) return;
      var compareEl = row.querySelector('.product-compare-price');
      var priceEl = row.querySelector('.product-price');
      if (!compareEl || !priceEl) return;

      var compareAt = parseMoney(compareEl.textContent);
      var price = parseMoney(priceEl.textContent);
      if (compareAt === null || price === null || compareAt <= price) return;

      var pct = Math.round(((compareAt - price) / compareAt) * 100);
      if (pct <= 0) return;

      var amount = Math.round(compareAt - price);

      var badge = document.createElement('span');
      badge.className = 'product-discount-badge';

      // Prijspsychologie: toon het grootste getal (bedrag vs. percentage).
      if (amount > pct) {
        badge.textContent = '€' + amount + ' KORTING';
      } else {
        badge.textContent = 'Bespaar ' + pct + '%';
      }

      row.appendChild(badge);
    });
  }

  function init() {
    injectStyle();
    addBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Herbereken bij variant-wissels / dynamische updates van de prijs.
  document.addEventListener('change', function () {
    setTimeout(addBadges, 300);
  });
})();
